import { useUserEventLogger } from '@repo/tracking-service';
import { List, Button } from '@zenterprise-inc/ui';
import Image from 'next/image';
import { useEffect } from 'react';

import { useRefundCardEvents } from '@/components/tax-refund/summary/hooks/useRefundCardEvents';
import s from '@/components/tax-refund/summary/summary.module.scss';

type Props = {
  className?: string;
  cardType: 'indis' | 'indis-income' | 'indis-tritx' | 'corps';
  cardLabel?: string;
  cardTitle: string;
  cardSubTitle?: string;
  buttonState?: {
    title: string;
    onClick?: () => void;
  };
  refundItem?: any;
  cardAnimate?: boolean;
};

const RefundSummaryCard = ({ className, cardType, cardLabel, cardTitle, cardSubTitle, refundItem, buttonState, cardAnimate = true }: Props) => {
  const businessType = cardType === 'corps' ? 'corps' : 'indis';
  const { sendViewEvent, sendClickEvent } = useUserEventLogger();
  const { cardViewEvent, buttonClickEvent } = useRefundCardEvents(refundItem, cardType, businessType);

  const cardConfig = {
    indis: {
      icon: 'fill-member-rg.svg',
      title: cardLabel
    },
    'indis-income': {
      icon: 'icg_won-arrow-counterclockwise_md.svg',
      title: `종합소득세·${cardLabel}`
    },
    'indis-tritx': {
      icon: 'icg_won-arrow-up_md.svg',
      title: `양도소득세·${cardLabel}`
    },
    corps: {
      icon: 'fill-mi-building-rg.svg',
      title: cardLabel
    }
  };
  const { icon, title } = cardConfig[cardType];

  useEffect(() => {
    if (cardViewEvent?.name) {
      sendViewEvent(cardViewEvent.name, cardViewEvent.attributes);
    }
  }, [cardViewEvent, sendViewEvent]);

  return (
    <div className={`${className} bg-white rounded-5 cursor-pointer ${cardAnimate ? 'transition-transform duration-150 ease-in-out hover:scale-[0.97]' : ''}`}>
      <List.Basic
        left={<Image src={`/images/illus-icons/${icon}`} width="40" height="40" alt={'section state icon'} />}
        overText={{
          text: title || '',
          color: 'gray.700'
        }}
        title={{
          text: cardTitle,
          titleStyle: 'font-bold'
        }}
        subText={cardSubTitle ? { text: cardSubTitle, color: 'gray.700' } : undefined}
        right={
          buttonState?.title
            ? {
                type: 'button',
                component: (
                  <Button.Box
                    state={buttonState.title === '상세' ? 'secondary' : 'primary'}
                    onClick={(event) => {
                      sendClickEvent(buttonClickEvent.name, buttonClickEvent.attributes);
                      event?.stopPropagation();
                      buttonState?.onClick?.();
                    }}
                  >
                    {buttonState.title}
                  </Button.Box>
                )
              }
            : undefined
        }
        listIcon={buttonState?.title === ''}
        onClick={buttonState?.onClick}
        className={`px-6 py-2 ${s.current_section_list_item}`}
      />
    </div>
  );
};

export default RefundSummaryCard;
